import React from 'react';
import cx from 'classnames';
import s from './AddWarehouseModal.module.css';
import { SearchModal } from '../SearchModal/SearchModal';

export class AddWarehouseModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isProjectListModalOpened: true,
            projectForAttachmentData: [],
        };
        this.onOtherWarehouseButtonClick = this.onOtherWarehouseButtonClick.bind(this);
        this.onProjectButtonClick = this.onProjectButtonClick.bind(this);
        this.clickWarehouseButton = this.clickWarehouseButton.bind(this);
    }

    componentDidMount() {
        this.getProjectForAttachmentList();
    }

    onProjectButtonClick() {
        this.setState({
            isProjectListModalOpened: true,
        });
        this.props.setWarehouseCreatingMode('project');
    }

    onOtherWarehouseButtonClick() {
        this.setState({
            isProjectListModalOpened: false,
        });
        this.props.setWarehouseCreatingMode('custom');
    }

    getProjectForAttachmentList() {
        fetch(routable.getRoute('availableForAttachmentProjectList'), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
        })
            .then((response) => response.json())
            .then((data) => {
                this.setState({
                    projectForAttachmentData: data.response,
                    isEmptyProjectForAttachmentList: data.response.length === 0,
                });
            });
    }

    clickWarehouseButton(warehouse) {
        this.props.addWarehouse({
            id: warehouse.id,
        });
        this.props.disableWarehouseAddingMode();
    }

    render() {
        return (
            <>
                <div style={this.props.style} className={s.modal}>
                    <div
                        className={cx(s.button, {
                            [s.activeButton]: this.state.isProjectListModalOpened,
                        })}
                    >
                        <div
                            data-id="project-button"
                            className={s.buttonWrapper}
                            onClick={this.onProjectButtonClick}
                        >
                            <span
                                className={cx(s.buttonIcon, {
                                    [s.buttonIconWhite]: this.state.isProjectListModalOpened,
                                    [s.buttonBlackIcon]: !this.state.isProjectListModalOpened,
                                })}
                            />
                            <span>
                                {i18next.t('AddWarehouseModal.render.onProject')}
                            </span>
                        </div>
                    </div>
                    <div
                        className={cx(s.button, {
                            [s.activeButton]: !this.state.isProjectListModalOpened,
                        })}
                        onClick={this.onOtherWarehouseButtonClick}
                        data-id="other-warehouse-button"
                    >
                        {i18next.t('AddWarehouseModal.render.onOther')}
                    </div>
                </div>
                {this.state.isProjectListModalOpened && (
                    <div
                        className={cx(s.additionalModal, {
                            [s.leftMode]: this.props.isLeftModeModal,
                        })}
                    >
                        <SearchModal
                            titleText={i18next.t('AddWarehouseModal.render.SearchModal.titleText')}
                            buttonClick={this.clickWarehouseButton}
                            buttonsData={this.state.projectForAttachmentData}
                            hideOverlay={this.props.disableWarehouseAddingMode}
                            isEmptyProjectForAttachmentList={
                                this.state.isEmptyProjectForAttachmentList
                            }
                        />
                    </div>
                )}
            </>
        );
    }
}
